import { render, staticRenderFns } from "./ed-input-form.vue?vue&type=template&id=f19d04a4&scoped=true&"
import script from "./ed-input-form.ts?vue&type=script&lang=ts&"
export * from "./ed-input-form.ts?vue&type=script&lang=ts&"
import style0 from "./ed-input-form.scss?vue&type=style&index=0&id=f19d04a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19d04a4",
  null
  
)

export default component.exports